



import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import { Suspense, useState } from 'react';
// react-date-range (the DateRange picker) is split out of app.js into the
// lazy/date-range.js WAR bundle, loaded on first render via React.lazy — see
// ./lazy-date-range. Its CSS is kept eager (link-injected on WA via the
// manifests' content_scripts.css; imported here for the website build).
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import LazyDateRange from './lazy-date-range';

interface BTTimelineProps {
    rangeDateInput?: { startDate: string | Date; endDate: string | Date };
    onValueUpdate: (output: { startDate: Date; endDate: Date; progressInPercentage: number }) => void;
}

const BTTimeline = ({ rangeDateInput, onValueUpdate }: BTTimelineProps) => {

    const [rangeDate, setRangeDate] = useState([
        {
            startDate: rangeDateInput ? new Date(rangeDateInput.startDate) : new Date(),
            endDate: rangeDateInput ? new Date(rangeDateInput.endDate) : new Date(),
            key: 'selection'
        }
    ]);




    const onChange = (item: unknown) => {
        const sel = (item as { selection?: { startDate?: Date; endDate?: Date; key?: string } }).selection ?? {};
        console.log(item)
        const selection = {
            startDate: sel.startDate ?? new Date(),
            endDate: sel.endDate ?? new Date(),
            key: sel.key ?? 'selection',
        };
        setRangeDate([selection])
        const startDate = selection.startDate;
        const endDate = selection.endDate;
        const today = new Date();
        let progressInPercentage = ((today.getTime() - startDate.getTime()) / (endDate.getTime() - startDate.getTime())) * 100;
        if(startDate.getTime() > today.getTime()){
            progressInPercentage = 0
        }
        progressInPercentage = Math.trunc(progressInPercentage)
        const output = {
            startDate,
            endDate,
            progressInPercentage,
        }

        onValueUpdate(output)
    }


    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Suspense fallback={<div style={{ minHeight: 300 }} aria-busy="true" />}>
                <LazyDateRange
                    editableDateInputs={true}
                    onChange={onChange}
                    moveRangeOnFirstSelection={true}
                    ranges={rangeDate}
                />
            </Suspense>
            {/* <BTButton sx={{ alignSelf: 'end', margin: '10px' }} color="primary" onClick={submit}>
                Save
            </BTButton> */}
        </div>

    )
}
export default BTTimeline